import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PdfSmallOrderViewComponent } from './pdf-small-order-view.component';


const routes: Routes = [
  {
    path: '',
    component: PdfSmallOrderViewComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PdfSmallOrderViewRoutingModule { }
